import isEqual from 'lodash-es/isEqual';
import React from 'react';
const ItemContext = React.createContext(undefined);
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useItemContext = () => {
    const itemContext = React.useContext(ItemContext);
    if (!itemContext) {
        throw new Error('You may have forgot to render <ItemContextProvider /> because ItemContext is not defined');
    }
    return itemContext;
};
export const ItemContextProvider = ({ itemContext, children }) => {
    return React.createElement(ItemContext.Provider, { value: itemContext }, children);
};
export const PlotItemContextProvider = React.memo(({ plot, override, children }) => {
    const itemContext = {
        availableMeasures: plot.availableMeasures,
        kind: 'plot',
        id: plot.id,
        name: plot.name,
        timezone: plot.timezone,
        location: plot.location,
        ...(override ?? {})
    };
    return React.createElement(ItemContext.Provider, { value: itemContext }, children);
}, (prev, next) => prev.plot.id === next.plot.id &&
    isEqual(prev.override, next.override) &&
    prev.children === next.children);
export const DeviceItemContextProvider = React.memo(({ device, override, children }) => {
    const itemContext = {
        availableMeasures: device.availableMeasures,
        kind: 'device',
        id: device.id,
        name: device.endUserName[1],
        timezone: device.timezone,
        location: device.location,
        ...(override ?? {})
    };
    return React.createElement(ItemContext.Provider, { value: itemContext }, children);
}, (prev, next) => prev.device.id === next.device.id &&
    isEqual(prev.override, next.override) &&
    prev.children === next.children);
export const StationItemContextProvider = React.memo(({ station, override, children }) => {
    const itemContext = {
        availableMeasures: station.availableMeasures,
        kind: 'station',
        id: station.deviceId,
        name: station.name,
        timezone: station.timezone,
        location: station.location,
        ...(override ?? {})
    };
    return React.createElement(ItemContext.Provider, { value: itemContext }, children);
}, (prev, next) => prev.station.id === next.station.id &&
    isEqual(prev.override, next.override) &&
    prev.children === next.children);
